<template lang="pug">
  div
    v-card.calendar-list-item( @click="onDayMenuClick" )
      v-flex.top
        v-layout
          v-flex.day {{offerItem.dayName}}
          v-flex.date {{date}}

      v-flex.bottom( )
        v-layout.group-box( v-if="!setFreeDay" )
          v-flex.types(v-for="(menuGroupItem, idx) in offerItem.menuGroupList" :key="idx")
            v-card.type(flat)
              calendar-list-item-type(:item="menuGroupItem" :countItems="offerItem.menuGroupList.length")
        v-layout( v-else )
          v-flex
            v-card(flat)
              calendar-list-item-type( :eventName="getEventName")
</template>

<script lang="ts">
import Vue from 'vue'

import DailyMenuOffer from '@/model/dailymenu/DailyMenuOffer'
import {
    CURRENT_UI_LANGUAGE,
    DAILY_MENU_OFFER_TEMPLATE,
    GET_CALENDAR_EVENTS,
    IS_DATA_CHANGED,
} from '@/store/getter-types'
import {SWITCH_DAILYMENU} from '@/store/action-types'
import CalendarListItemType from '@/components/dailymenu/calendar/CalendarListItemType.vue'
import Moment from 'moment'
import CalendarEventForDay from "@/model/calendar/CalendarEventForDay"
import moment from "moment";
import {Component, Prop, Watch} from "vue-property-decorator"
import router from "@/router";
import {RawLocation} from "vue-router";

@Component({
  components: {
    CalendarListItemType
  }
})

export default class CalendarListItem extends Vue {

  private day: string | null = null
  private date: string | null = null
  private lastSelectedDate: string | null = null
  private setFreeDay: boolean = false
  private events: CalendarEventForDay[] | undefined = undefined

  @Prop({type: Object as () => DailyMenuOffer}) offerItem!: DailyMenuOffer
  @Prop({type: Boolean}) weekHasChanged!: boolean

  get isDataChanged(): boolean {
    return this.$store.getters[IS_DATA_CHANGED]
  }

  get currentDate(): any {
    return this.$store.getters[DAILY_MENU_OFFER_TEMPLATE]
  }

  getCurrentEvent(): void {
    if (this.events) {
      const foundEvent: CalendarEventForDay | undefined = this.events.find((item: CalendarEventForDay) => moment(item.date).format('D.M.YYYY') == this.date)
      this.setFreeDay = !!foundEvent
    } else {
      this.setFreeDay = false
    }
  }

  get getEventName(): string {
    if (this.events) {
      const foundEvent: CalendarEventForDay | undefined = this.events!.find((item: CalendarEventForDay) => moment(item.date).format('D.M.YYYY') == this.date)
      if (foundEvent !== undefined) {
        if (foundEvent!.kind.name == 'holiday') {
          return 'Prázdniny'
        } else if (foundEvent!.kind.name == 'free_day') {
          return 'Voľný deň'
        }
      }
    }

    return ''
  }

  @Watch('weekHasChanged')
  watchWeekHasChanged() {
    this.events = this.$store.getters[GET_CALENDAR_EVENTS]
    this.getCurrentEvent()
  }

  @Watch('offerItem')
  watchItem(newVal: any): void {

    if (newVal) {

      this.day = newVal.dayName
      this.date = newVal.formatedDate

      const formattedDate = Moment(newVal.date).format("Y-MM-DD")
      const formattedSelectedDate = Moment(this.lastSelectedDate).format("Y-MM-DD")

      if (formattedDate == formattedSelectedDate) {
        this.onDayMenuClick()
      }
    }
  }

  @Watch('currentDate')
  watchCurrentDate(newVal: any): void {
    this.lastSelectedDate = newVal.date
  }

  @Watch('$route')
  watchRoute(to: any, from: any): void {

    this.events = this.$store.getters[GET_CALENDAR_EVENTS]

    this.getCurrentEvent()
  }


  onDayMenuClick(): void {

    this.$store.dispatch(SWITCH_DAILYMENU, this.offerItem)

    router.push({
      name: 'Dailymenu',
      params: {
        isoWeek: this.$route.params.isoWeek,
        date: moment(this.date, "D.M.YYYY").format('YYYY-MM-DD')
      }
    } as RawLocation).catch((err: Error) => {
    })
  }

  mounted(): void {

    this.events = this.$store.getters[GET_CALENDAR_EVENTS]

    if (this.offerItem) {
      this.day = this.offerItem.dayName
      this.date = this.offerItem.formatedDate
    }


    this.getCurrentEvent()
  }
}
</script>

<style lang="stylus" scoped>

.calendar-list-item
  padding 2%
  margin 2% 0

  .top
    text-transform capitalize

    .date
      text-align right
      flex 3
      margin 0 10px

  .bottom
    font-size 1.4em
    border-top 1px solid silver
    margin 0

    .next
      margin 0 10px
      flex 1

      .next-icon
        flex 1

    .group-box
      flex-direction column
      flex 4

      .storno
        background-color orange

      .types
        align-items center
        text-align center

        .type
          margin 1%

          .theme--light.v-card
            background-color white

          .type_label
            font-weight bold
            background-color #c0dbff
            font-size 1.2em

          .notSelectedMenu
            background-color #fadacd

          .selectedMenu
            background-color #d5f9b2

          .subtype
            flex-direction row

            .subtype_row
              border-bottom 1px solid #fff

              .subtype_label
                flex 4
                text-align right

              .subtype_value
                flex 3

            .notSelectedMenu
              background-color #fadacd

            .selectedMenu
              background-color #d5f9b2

@media screen and (max-width: 2000px)

  .top
    font-size 1.2em

@media screen and (max-width: 1400px)

  .top
    font-size 1.4em
</style>
